export const unifiedModuleColors = {
  white: 'white',
  grey: 'grey',
  lightBlue: 'light-blue',
  mistyBlue: 'misty-blue',
  blue: 'blue',
  darkBlue: 'dark-blue',
  black: 'black',
  lightPurple: 'light-purple',
  lightYellow: 'light-yellow',
  lightGreen: 'light-green',
  quaternaryPurpleXWeak: 'quaternary-purple-xweak',
  primaryBlueXWeak: 'primary-blue-xweak',
  primaryBlueWeak: 'primary-blue-weak',
  primaryBlueStrong: 'primary-blue-strong',
  primaryBlueXStrong: 'primary-blue-xstrong',
  primaryBlueXXStrong: 'primary-blue-xxstrong',
  neutralGreyXWeak: 'neutral-grey-xweak',
  neutralGreyWeak: 'neutral-grey-weak',
  neutralGreyXStrong: 'neutral-grey-xstrong',
  neutralGreyXXStrong: 'neutral-grey-xxstrong',
  neutralPrimary: 'neutral-primary',
  tertiaryYellowXWeak: 'tertiary-yellow-xweak',
};

const COLOR_MAP: Record<string, string> = {
  [unifiedModuleColors.white]: 'var(--cds-color-neutral-background-primary)',
  [unifiedModuleColors.grey]: 'var(--cds-color-neutral-background-primary-weak)',
  [unifiedModuleColors.lightBlue]: 'var(--cds-color-emphasis-primary-background-xweak)',
  [unifiedModuleColors.mistyBlue]: 'var(--cds-color-emphasis-primary-background-weak)',
  [unifiedModuleColors.blue]: 'var(--cds-color-emphasis-primary-background-strong)',
  [unifiedModuleColors.darkBlue]: 'var(--cds-color-emphasis-primary-background-xxstrong)',
  [unifiedModuleColors.black]: 'var(--cds-color-neutral-primary)',
  [unifiedModuleColors.lightPurple]: `var(--cds-color-callouts-background-secondary-weak)`,
  [unifiedModuleColors.lightYellow]: `var(--cds-color-callouts-background-tertiary-weak)`,
  [unifiedModuleColors.lightGreen]: `var(--cds-color-feedback-background-success-weak)`,
  [unifiedModuleColors.quaternaryPurpleXWeak]: `var(--cds-color-emphasis-quaternary-background-xweak)`,
  [unifiedModuleColors.primaryBlueXWeak]: `var(--cds-color-emphasis-primary-background-xweak)`,
  [unifiedModuleColors.primaryBlueWeak]: `var(--cds-color-emphasis-primary-background-weak)`,
  [unifiedModuleColors.primaryBlueStrong]: `var(--cds-color-emphasis-primary-background-strong)`,
  [unifiedModuleColors.primaryBlueXStrong]: `var(--cds-color-emphasis-primary-background-xstrong)`,
  [unifiedModuleColors.primaryBlueXXStrong]: `var(--cds-color-emphasis-primary-background-xxstrong)`,
  [unifiedModuleColors.neutralGreyWeak]: `var(--cds-color-emphasis-neutral-background-weak)`,
  [unifiedModuleColors.neutralGreyXWeak]: `var(--cds-color-emphasis-neutral-background-xweak)`,
  [unifiedModuleColors.neutralGreyXStrong]: `var(--cds-color-emphasis-neutral-background-xstrong)`,
  [unifiedModuleColors.neutralGreyXXStrong]: `var(--cds-color-emphasis-neutral-background-xxstrong)`,
  [unifiedModuleColors.neutralPrimary]: `var(--cds-color-neutral-background-primary)`,
  [unifiedModuleColors.tertiaryYellowXWeak]: `var(--cds-color-emphasis-tertiary-background-xweak)`,
};

export function getColorFromColorName(colorName?: string | null) {
  if (!colorName || colorName === 'none') {
    return null;
  }

  return COLOR_MAP[colorName] ?? null;
}

export function isInvertedColor(colorName: string) {
  return [
    'black',
    'dark-blue',
    'blue',
    'neutral-grey-xstrong',
    'neutral-grey-xxstrong',
    'primary-blue-strong',
    'primary-blue-xstrong',
    'primary-blue-xxstrong',
  ].includes(colorName);
}

export function getFgColorFromBgColorName(colorName: string) {
  if (isInvertedColor(colorName)) {
    return 'var(--cds-color-neutral-primary-invert)';
  } else {
    return 'var(--cds-color-neutral-primary)';
  }
}
